import { RESPONSES } from 'utils/useCms';

const parameterLocationLabels = RESPONSES.PARAMETER.LOCATIONS as Record<
  string,
  string
>;

export { parameterLocationLabels as parameterLocations };
